import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-up-red",
  "use": "icon-up-red-usage",
  "viewBox": "0 0 14 11",
  "content": "<symbol viewBox=\"0 0 14 11\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-up-red\">\n<path id=\"icon-up-red_Polygon 6\" d=\"M6.13398 0.499999C6.51888 -0.166667 7.48112 -0.166667 7.86603 0.5L13.0622 9.5C13.4471 10.1667 12.966 11 12.1962 11H1.80385C1.03405 11 0.552922 10.1667 0.937822 9.5L6.13398 0.499999Z\" fill=\"#FF0606\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol